namespace Application.Models {
    'use strict';

    export class ComponentOperation {
        public component: string;
        public operation: string;

        constructor(component: string, operation: string) {
            this.component = component;
            this.operation = operation;
        }

        public toString(): string {
            return this.component + " " + this.operation;
        }
    }
}